/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Icy_Blue_Liger_ProsperInputs */

const es_icy_blue_liger_prosper = /** @type {(inputs: Icy_Blue_Liger_ProsperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ahora`)
};

const gl_icy_blue_liger_prosper = /** @type {(inputs: Icy_Blue_Liger_ProsperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`agora`)
};

const en_icy_blue_liger_prosper = /** @type {(inputs: Icy_Blue_Liger_ProsperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`now`)
};

/**
* | output |
* | --- |
* | "now" |
*
* @param {Icy_Blue_Liger_ProsperInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const icy_blue_liger_prosper = /** @type {((inputs?: Icy_Blue_Liger_ProsperInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Icy_Blue_Liger_ProsperInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_icy_blue_liger_prosper(inputs)
	if (locale === "en") return en_icy_blue_liger_prosper(inputs)
	return es_icy_blue_liger_prosper(inputs)
});